import React, { useEffect, useRef, useState } from 'react';
import styles from './DropdownButton.module.css';
import { ReactComponent as SelectDropdownIndicatorIcon } from '../../../assets/SelectDropdownIndicator.svg';
import { Button, ButtonProps, Popover, PopoverOptions } from '@round/ui-kit';
import { FCWithChildren } from '../../../utils/utils.types';
import cn from 'classnames';

export type DropdownButtonProps = ButtonProps & {
    label: string;
    popoverOptions?: PopoverOptions;
};

const DropdownButton: FCWithChildren<DropdownButtonProps> = ({ label, children, popoverOptions, ...buttonProps }) => {
    const [shouldFocus, setShouldFocus] = useState(false);
    const buttonRef = useRef<HTMLButtonElement | null>(null);
    const popoverRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (shouldFocus) {
            buttonRef?.current?.focus();
        } else {
            buttonRef?.current?.blur();
        }
    }, [shouldFocus, buttonRef]);

    const options: PopoverOptions = {
        ...{
            placement: 'bottom-start',
        },
        ...popoverOptions,
    };

    return (
        <div ref={popoverRef}>
            <Button ref={buttonRef} {...buttonProps} className={cn(styles.button, buttonProps.className)}>
                {label}
                <SelectDropdownIndicatorIcon className={cn(styles.dropdownIcon, { [styles.isOpen]: shouldFocus })} />
            </Button>
            <Popover
                disabled={buttonProps.disabled}
                anchorElement={popoverRef.current}
                showOn="click"
                options={options}
                onShowPopoverChange={() => setShouldFocus((prev) => !prev)}
            >
                {children}
            </Popover>
        </div>
    );
};

export default DropdownButton;
